
import OpenOtherApi from '@/api/OpenOtherApi';
import { defineComponent, inject, onMounted, ref } from 'vue';
import { ShareAltOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { useRoute } from 'vue-router';

export default defineComponent({
  props: ['query'],
  components: {
    ShareAltOutlined
  },
  setup (props) {
    const userCustomFields = ref<any []>([])
    const hasPermission: any = inject('hasPermission')
    let userId: any = null
    const formatDate = 'YYYY/MM/DD'
    const formatDateTime = 'YYYY/MM/DD HH:mm:ss'
    function loadUseCustomFields (userId: number) {
      if (!userId) return
      userCustomFields.value = []
      OpenOtherApi.getCustomFields({
        userId,
        scope: 'engineer'
      }).then(data => {
        const customFields = data;
        for (let i = 0; i < customFields.length; i++) {
          const customField = customFields[i];
          const { type, value, userCustomFieldId, defaultValue, customFieldOptions } = customField
          const userCustomField: any = { id: userCustomFieldId, type, value, customField: null };

          if (type === 'options') {
            const options = JSON.parse(customFieldOptions)
            customField.customFieldOptions = options
            if ((value === undefined || value === '') && defaultValue) {
              const index = options.findIndex(op => op.value === defaultValue)
              if (index > -1) {
                userCustomField.value = defaultValue;
              }
            }
          } else if (type === 'multi_options') {
            const options = JSON.parse(customFieldOptions)
            customField.customFieldOptions = options;
            if (value === undefined || value === '') {
              const defaultOps = options.filter(op => op.defaultValue).map(op => op.value);
              userCustomField.value = defaultOps
            } else {
              userCustomField.value = value.split(',')
            }
          } else if (type === 'cascade_options') {
            userCustomField.value = value ? value.split('/') : []
            customField.customFieldOptions = JSON.parse(customFieldOptions);
          } else if (type === 'checkbox') {
            userCustomField.value = value === 'true'
          } else if (type === 'ip' || type === 'url' || type === 'mobile_phone' || type === 'currency') {
            userCustomField.type = 'text';
          } else if (type === 'date_to_date') {
            if (value) {
              const times = value.split('-');
              userCustomField.value = [times[0], times[1]]
            } else {
              userCustomField.value = []
            }
          }

          if (customField.url) {
            if (customField.url.toLowerCase().indexOf('http://') !== 0) {
              customField.url = 'http://' + customField.url;
            }
            if (customField.url.indexOf('?') < 0) {
              userCustomField.fromParams = '?'
            } else {
              userCustomField.fromParams = '&'
            }
            let valueUrl = String(customField.url);
            if (valueUrl.indexOf('{value}') > 0) {
              valueUrl = valueUrl.replaceAll('{value}', userCustomField.value);
            } else {
              valueUrl = valueUrl + userCustomField.value;
            }
            userCustomField.valueUrl = valueUrl;
          }

          userCustomField.customField = customField;
          customField.moreField = Boolean(customField.required)
          userCustomFields.value.push(userCustomField);
        }
      })
    }

    function handleSubmit () {
      if (!userId) return
      const submitData: any[] = []
      userCustomFields.value.forEach(item => {
        const { customField: { id, type }, value } = item
        const option: any = { customFieldId: id, userId, value }
        if (type === 'multi_options') {
          option.value = value.join(',')
        } else if (type === 'cascade_options') {
          option.value = value.join('/')
        } else if (type === 'date_to_date') {
          option.value = value.join('-')
        }
        submitData.push(option)
      })
      OpenOtherApi.updateUserCustomFields(submitData)
        .then(() => {
          message.success('资料更新成功')
        })
    }

    onMounted(() => {
      const { userId: pUserId } = props.query // 父级传来的
      const { userId: uUserId } = useRoute().query // 路由携带的
      userId = pUserId || uUserId
      loadUseCustomFields(userId)
    })

    return {
      formatDate,
      formatDateTime,
      userCustomFields,
      hasPermission,
      handleSubmit
    }
  }
})
